import { render } from "./RightPaneBottom.vue?vue&type=template&id=52114528&scoped=true"
import script from "./RightPaneBottom.vue?vue&type=script&lang=js"
export * from "./RightPaneBottom.vue?vue&type=script&lang=js"

import "./RightPaneBottom.vue?vue&type=style&index=0&id=52114528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52114528"]])

export default __exports__